import { Suspense } from "react";
import Loader from "../../components/loader/Loader";
import { Navigate, Route, Routes } from "react-router-dom";
import Login from "../../pages/login/Login";
import PageNotFound from "../../pages/PageNotFound";
import ForgetPassword from "../../pages/forgot/ForgotPassword";
import Signup from "../../pages/signup/Signup";
import ChangePassword from "../../pages/changePassword/ChangePassword";
import Home from "../../pages/home/Home";
import Body from "../../components/body/Body";
import Faq from "../../pages/faq/Faq";
import TermsAndConditions from "../../pages/terms_and_coditions/TermsAndConditions";
import Privacy from "../../pages/privacy/Privacy";
import About from "../../pages/about/About";
import Contact from "../../pages/contact/Contact";
import Blog from "../../pages/blog/Blog";
import RefundPolicy from "../../pages/refundPolicy/RefundPolicy";
import Courses from "../../pages/courses/Courses";

export const PublicRoutes = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        <Route path="/" element={<Home />}>
          <Route path="/" element={<Body />} />
          <Route path="/blog" element={<Blog />} />

          <Route path="/contact" element={<Contact />} />

          <Route path="/about" element={<About />} />

          <Route path="/privacy_policy" element={<Privacy />} />

          <Route
            path="/terms_and_conditions"
            element={<TermsAndConditions />}
          />

          <Route path="/faq" element={<Faq />} />

          <Route path="/refund_and_policy" element={<RefundPolicy />} />
          <Route path="/forget-password" element={<ForgetPassword />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/reset-password" element={<ChangePassword />} />
          <Route path="/login" element={<Login />} />
        </Route>
       
        {/* <Route path="/login" element={<Login />} />
        <Route path="/lms" element={<Login />} /> */}
        <Route path="*" element={<Navigate to="/login" />} />
        {/* <Route path="*" element={<PageNotFound />} /> */}
      </Routes>
    </Suspense>
  );
};
